import { render, staticRenderFns } from "./PathwayAddCourseModal.vue?vue&type=template&id=a67320f8&"
import script from "./PathwayAddCourseModal.vue?vue&type=script&lang=js&"
export * from "./PathwayAddCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports